@import 'styles/mixins';
@import 'styles/variables';

.header {
  @include xl-semibold;

  align-items: center;
  color: $almanac-black;
  display: flex;
  justify-content: space-between;
  height: 66px;
  padding: 16px 16px 8px;
}

.backIcon {
  margin-right: 4px;
  height: 36px;
  width: 36px;

  svg {
    path {
      fill: $grey-40;
    }
  }
}

.body {
  padding: 20px 24px 24px 24px;
}

.label {
  @include lg-medium;
  color: $grey-90;
  margin-bottom: 12px;
}

.inviteesField {
  border: 1px solid $grey-10;
  border-radius: 6px;
  display: flex;
  column-gap: 4px;
  align-items: center;
  padding: 2px 8px;
  margin-bottom: 36px;
}

.inviteesInput {
  flex: 1;
}

.footer {
  @include md-regular;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 24px 16px 24px;
  justify-content: right;
}
